"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 4.16669C20.8796 4.16669 16.8517 5.38854 13.4257 7.67774C9.99969 9.96693 7.32943 13.2207 5.7526 17.0274C4.17577 20.8342 3.76321 25.0231 4.56706 29.0644C5.37092 33.1057 7.35511 36.8178 10.2687 39.7314C13.1823 42.645 16.8944 44.6292 20.9357 45.433C24.977 46.2369 29.1659 45.8243 32.9727 44.2475C36.7795 42.6707 40.0332 40.0004 42.3224 36.5744C44.6116 33.1484 45.8334 29.1205 45.8334 25C45.8334 22.2641 45.2946 19.5551 44.2476 17.0274C43.2006 14.4998 41.666 12.2032 39.7315 10.2686C37.7969 8.33407 35.5003 6.7995 32.9727 5.75253C30.445 4.70556 27.736 4.16669 25.0001 4.16669ZM25.0001 42.625C21.5042 42.625 18.0869 41.5878 15.1807 39.6447C12.2745 37.7016 10.0102 34.94 8.67427 31.7094C7.33836 28.4788 6.99094 24.9245 7.67599 21.4964C8.36105 18.0683 10.0478 14.9205 12.5227 12.4514C14.9976 9.98233 18.1494 8.30304 21.5791 7.62608C25.0088 6.94912 28.5623 7.30493 31.7898 8.64847C35.0172 9.99201 37.7734 12.2629 39.7097 15.1736C41.6459 18.0844 42.675 21.5041 42.6668 25C42.6668 29.6855 40.8055 34.1791 37.4923 37.4922C34.1792 40.8054 29.6856 42.6667 25.0001 42.6667V42.625Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.9793 23.4375H26.5626V16.0209C26.5626 15.6065 26.398 15.209 26.1049 14.916C25.8119 14.623 25.4145 14.4584 25.0001 14.4584C24.5857 14.4584 24.1883 14.623 23.8952 14.916C23.6022 15.209 23.4376 15.6065 23.4376 16.0209V23.4375H16.0209C15.6065 23.4375 15.2091 23.6021 14.9161 23.8952C14.623 24.1882 14.4584 24.5856 14.4584 25C14.4584 25.4144 14.623 25.8118 14.9161 26.1049C15.2091 26.3979 15.6065 26.5625 16.0209 26.5625H23.4376V33.9792C23.4376 34.3936 23.6022 34.791 23.8952 35.084C24.1883 35.3771 24.5857 35.5417 25.0001 35.5417C25.4145 35.5417 25.8119 35.3771 26.1049 35.084C26.398 34.791 26.5626 34.3936 26.5626 33.9792V26.5625H33.9793C34.3937 26.5625 34.7911 26.3979 35.0841 26.1049C35.3771 25.8118 35.5418 25.4144 35.5418 25C35.5418 24.5856 35.3771 24.1882 35.0841 23.8952C34.7911 23.6021 34.3937 23.4375 33.9793 23.4375Z",
    fill: fill
  }));
};

exports["default"] = _default;